import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import QuickNews from "./components/QuickNews";
import FeaturedZone from "./components/FeaturedZone";
import TimelineFeed from "./components/TimelineFeed";
import RankPanel from "./components/RankPanel";
import SectionTitle from "./components/SectionTitle";
import CollectionsBand from "./components/CollectionsBand";
import CommunityZone from "./components/CommunityZone";
import FloorUpdates from "./components/FloorUpdates";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <QuickNews />

        <FeaturedZone />

        <section id="feed" className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-12">
          <SectionTitle
            eyebrow="持续吃瓜"
            title="瓜田时间线 · 蹲帖快讯流"
            desc="盖楼蹲帖里的每一层进展都实时归档，楼层跟进最新动向"
          />
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <TimelineFeed />
            </div>
            <div className="lg:col-span-1">
              <RankPanel />
            </div>
          </div>
        </section>

        <CollectionsBand />
        <CommunityZone />
        <FloorUpdates />
      </main>
      <Footer />
    </div>
  );
}